"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getProcessorErrorCode = exports.getErrorResolution = exports.isTerminalError = exports.TerminalErrorCodesResolution = exports.NonTerminalErrorCodes = exports.TerminalErrorCodes = exports.ProcessorErrorCodes = void 0;
// Most of these can be found here
// https://developer.paypal.com/docs/api/orders/v2/#orders_capture!c=201&path=purchase_units/payments/captures/processor_response/avs_code&t=response
// Others are processor specific (VISA, MASTER, etc)
// These are the most occurring ones, as seen so far.
exports.ProcessorErrorCodes = {
    '1000': 'PARTIAL_AUTHORIZATION',
    '1300': 'INVALID_DATA_FORMAT',
    '1310': 'INVALID_AMOUNT',
    '1312': 'INVALID_TRANSACTION_CARD_ISSUER_ACQUIRER',
    '1317': 'INVALID_CAPTURE_DATE',
    '1320': 'INVALID_CURRENCY_CODE',
    '1330': 'INVALID_ACCOUNT',
    '1335': 'INVALID_ACCOUNT_RECURRING',
    '1340': 'INVALID_TERMINAL',
    '1350': 'INVALID_MERCHANT',
    '1352': 'RESTRICTED_OR_INACTIVE_ACCOUNT',
    '1360': 'BAD_PROCESSING_CODE',
    '1370': 'INVALID_MCC',
    '1380': 'INVALID_EXPIRATION',
    '1382': 'INVALID_CARD_VERIFICATION_VALUE',
    '1384': 'INVALID_LIFE_CYCLE_OF_TRANSACTION',
    '1390': 'INVALID_ORDER',
    '1393': 'TRANSACTION_CANNOT_BE_COMPLETED',
    '5100': 'GENERIC_DECLINE',
    '5110': 'CVV2_FAILURE',
    '5120': 'INSUFFICIENT_FUNDS',
    '5130': 'INVALID_PIN',
    '5135': 'DECLINED_PIN_TRY_EXCEEDED',
    '5140': 'CARD_CLOSED',
    '5150': 'PICKUP_CARD_SPECIAL_CONDITIONS',
    '5160': 'UNAUTHORIZED_USER',
    '5170': 'AVS_FAILURE',
    '5180': 'INVALID_OR_RESTRICTED_CARD',
    '5190': 'SOFT_AVS',
    '5200': 'DUPLICATE_TRANSACTION',
    '5210': 'INVALID_TRANSACTION',
    '5400': 'EXPIRED_CARD',
    '5500': 'INCORRECT_PIN_REENTER',
    '5650': 'DECLINED_SCA_REQUIRED',
    '5700': 'TRANSACTION_NOT_PERMITTED',
    '5710': 'TX_ATTEMPTS_EXCEED_LIMIT',
    '5800': 'REVERSAL_REJECTED',
    '5900': 'INVALID_ISSUE',
    '5910': 'ISSUER_NOT_AVAILABLE_NOT_RETRIABLE',
    '5920': 'ISSUER_NOT_AVAILABLE_RETRIABLE',
    '5930': 'CARD_NOT_ACTIVATED',
    '6300': 'ACCOUNT_NOT_ON_FILE',
    '7600': 'APPROVED_NON_CAPTURE',
    '7700': 'ERROR_3DS',
    '7710': 'AUTHENTICATION_FAILED',
    '7800': 'BIN_ERROR',
    '8000': 'PROCESSOR_SYSTEM_ERROR',
    '9500': 'SUSPECTED_FRAUD',
    '9510': 'SECURITY_VIOLATION',
    '9520': 'LOST_OR_STOLEN',
    '9540': 'REFUSED_CARD',
    '0390': 'ACCOUNT_NOT_FOUND',
    '0500': 'DO_NOT_HONOR',
    '0580': 'UNAUTHORIZED_TRANSACTION',
    '10BR': 'ISSUER_REJECTED',
    PCVV: 'CVV_FAILURE',
    PPEF: 'EXPIRED_FUNDING_INSTRUMENT',
    PPEL: 'EXCEEDS_FREQUENCY_LIMIT',
    PPMC: 'BLOCKED_Mastercard',
    PP06: 'ISSUING_BANK_ERROR', // Specific to VISA Cards
};
exports.TerminalErrorCodes = {
    UNKNOWN_FAILURE: 'UNKNOWN_FAILURE',
    DECLINED: 'DECLINED',
    PAYER_ACTION_REQUIRED: 'PAYER_ACTION_REQUIRED',
    PROCESSOR_FAILURE: 'PROCESSOR_FAILURE',
    INSTRUMENT_DECLINED: 'INSTRUMENT_DECLINED',
    ISSUING_BANK_ERROR: 'ISSUING_BANK_ERROR',
    INVALID_DATA_FORMAT: 'INVALID_DATA_FORMAT',
    INSUFFICIENT_FUNDS: 'INSUFFICIENT_FUNDS',
    EXPIRED_CARD: 'EXPIRED_CARD',
    DO_NOT_HONOR: 'DO_NOT_HONOR',
};
var NonTerminalErrorCodes;
(function (NonTerminalErrorCodes) {
    NonTerminalErrorCodes["DECLINED_PLEASE_RETRY"] = "DECLINED_PLEASE_RETRY";
    NonTerminalErrorCodes["APPROVED"] = "APPROVED";
})(NonTerminalErrorCodes || (exports.NonTerminalErrorCodes = NonTerminalErrorCodes = {}));
exports.TerminalErrorCodesResolution = {
    [exports.TerminalErrorCodes.UNKNOWN_FAILURE]: "We're sorry, your payment was not processed successfully. Please try again later or contact customer support for assistance.",
    [exports.TerminalErrorCodes.DECLINED]: "We're sorry, your payment was declined. Please make sure you have sufficient funds available and that your payment information is correct, then try again.",
    [exports.TerminalErrorCodes.PAYER_ACTION_REQUIRED]: 'Payment failed due to additional authorization or authentication requirements for your payment method. Please check your payment method or contact your bank to ensure that it is authorized for this payment.',
    [exports.TerminalErrorCodes.PROCESSOR_FAILURE]: "We're sorry, your payment was not processed successfully due to a technical error. Please try again later or contact customer support for assistance.",
    [exports.TerminalErrorCodes.ISSUING_BANK_ERROR]: "We're sorry, we were unable to process your payment due to an error with your bank. Please contact your bank for assistance in resolving the issue.",
    [exports.TerminalErrorCodes.INSTRUMENT_DECLINED]: "We're sorry, your payment instrument was declined. Please try a different payment method or contact your bank for assistance.",
    [exports.TerminalErrorCodes.INVALID_DATA_FORMAT]: 'Invalid data format. Please check and try again.',
    [exports.TerminalErrorCodes.INSUFFICIENT_FUNDS]: 'Insufficient funds. Please try again with a different payment method.',
    [exports.TerminalErrorCodes.EXPIRED_CARD]: 'Expired card. Please try again with a different payment method.',
    [exports.TerminalErrorCodes.DO_NOT_HONOR]: 'Your transaction has been declined. Please contact your bank for assistance in resolving the issue.',
};
const isProcessorError = (errorCode) => errorCode in exports.ProcessorErrorCodes;
const isPayPalError = (errorCode) => errorCode in exports.TerminalErrorCodes;
const isTerminalError = (errorCode) => isPayPalError(errorCode) || isProcessorError(errorCode);
exports.isTerminalError = isTerminalError;
const getErrorResolution = (errorCode) => {
    let resolution;
    if (isProcessorError(errorCode)) {
        const derivedErrorCode = String(exports.ProcessorErrorCodes[errorCode]);
        resolution =
            derivedErrorCode in exports.TerminalErrorCodesResolution
                ? exports.TerminalErrorCodesResolution[derivedErrorCode]
                : exports.TerminalErrorCodesResolution[exports.TerminalErrorCodes.PROCESSOR_FAILURE];
    }
    else if (isPayPalError(errorCode)) {
        resolution = exports.TerminalErrorCodesResolution[errorCode];
    }
    else {
        resolution = exports.TerminalErrorCodesResolution[exports.TerminalErrorCodes.UNKNOWN_FAILURE];
    }
    return `${resolution}. Code:${errorCode}`;
};
exports.getErrorResolution = getErrorResolution;
const getProcessorErrorCode = (errorStatus, capture) => {
    if (errorStatus === 'COMPLETED') {
        // We can proceed to extract the reason this failed
        // In the captured data;
        /**
         * mainCapturedPayment = captureOrder?.purchase_units?.[0]?.payments?.captures[0]
         * Three fields are very important here namely: status, status_details, and processor_response.
         * processor_response is usually the main reason for the failure when it exists.
         */
        const { status, status_details = null, processor_response = null } = capture;
        let captureStatus = String(status);
        if (status && (0, exports.isTerminalError)(captureStatus)) {
            // Check if the error is from the processor
            if (processor_response === null || processor_response === void 0 ? void 0 : processor_response.response_code) {
                captureStatus = String(exports.ProcessorErrorCodes[processor_response === null || processor_response === void 0 ? void 0 : processor_response.response_code]);
            }
            else if (status_details === null || status_details === void 0 ? void 0 : status_details.reason) {
                captureStatus = exports.TerminalErrorCodes[status_details === null || status_details === void 0 ? void 0 : status_details.reason];
            }
            const errorData = {
                errorStatus,
                derivedStatusCode: captureStatus,
                resolution: (0, exports.getErrorResolution)(captureStatus),
            };
            return errorData;
        }
    }
    else if (errorStatus === exports.TerminalErrorCodes.PAYER_ACTION_REQUIRED) {
        // There will be no capture in this reponse so we return a
        // generic message for donor to follow up.
        // This also triggers the resume flow.
        const errorData = {
            errorStatus,
            derivedStatusCode: exports.TerminalErrorCodes.PAYER_ACTION_REQUIRED,
            resolution: (0, exports.getErrorResolution)(errorStatus),
        };
        return errorData;
    }
    const errorData = {
        errorStatus,
        derivedStatusCode: exports.TerminalErrorCodes.UNKNOWN_FAILURE,
        resolution: (0, exports.getErrorResolution)(errorStatus),
    };
    return errorData;
};
exports.getProcessorErrorCode = getProcessorErrorCode;
//# sourceMappingURL=payPalErrors.js.map